<template>
    <div>
        <top-header></top-header>
        <div class="router-ul">
            <h1 @click="openStudyDialog">单词路由</h1>
            <table>
                <template  v-for="(item, index) in $router.options.routes">
                    <tr>
                        <td>{{index + 1}}</td>
                        <td>
                            <router-link :to="item.path">{{item.meta.title}}</router-link>
                        </td>
                        <td>
                            <router-link :to="item.path">{{item.path}}</router-link>
                        </td>
                        <td>
                            <router-link :to="item.path">查看</router-link>
                        </td>
                    </tr>
                    <template v-for="(child, idx) in item.children">
                        <tr>
                            <td>{{index + 1}}-{{idx+1}}</td>
                            <td>
                                ----<router-link :to="item.path + '/' + child.path">{{child.meta.title}}</router-link>
                            </td>
                            <td>
                                <router-link :to="item.path + '/' + child.path">{{item.path + '/' + child.path}}</router-link>
                            </td>
                            <td>
                                <router-link :to="item.path + '/' + child.path">查看</router-link>
                            </td>
                        </tr>
                        <template v-for="(child1, idx1) in child.children">
                            <tr>
                                <td>{{index + 1}}-{{idx+1}}-{{idx1+1}}</td>
                                <td>
                                    --------<router-link :to="item.path + '/' + child.path + '/'+child1.path">{{child1.meta.title}}</router-link>
                                </td>
                                <td>
                                    <router-link :to="item.path + '/' + child.path + '/'+child1.path">{{item.path + '/' + child.path + '/'+child1.path}}</router-link>
                                </td>
                                <td>
                                    <router-link :to="item.path + '/' + child.path + '/'+child1.path">查看</router-link>
                                </td>
                            </tr>
                        </template>
                    </template>
                </template>
            </table>
        </div>
    </div>
</template>

<script>
    import topHeader from "@/components/common/topHeader";
    import DialogStudy from "@/components/common/dialogStudy";

    export default {
        name: "home",
        components: {topHeader},
        data() {
            return {
            };
        },
        methods: {
            openStudyDialog () {
                let data = {
                    title: '测试'
                }
                DialogStudy({
                    title: '测试主体',
                    onClose: ()=>{
                        console.log('关闭=====>', 'close')
                    },
                    success: (res)=>{
                        console.log('res=====>', res)
                    }
                })
            }
        },
        created() {
            console.log('router=====>', this.$router.options.routes)
        },
    }
</script>

<style scoped lang='less'>
.router-ul{
    margin: 20px 100px;
    line-height: 2;
    td{
        padding: 6px 20px;
    }
}
</style>